export default __webpack_public_path__ + "static/heading_about_us-c4c66b988cf1162c528b4c1c90f551e4.svg";